import React from 'react';
import { ArrowLeftLG, formatDate } from '../../normalizer';
import CustomButton from '../../shared/CustomButton';
import ReactPaginate from 'react-paginate';

const getStatusClass = (state) => {
  if (!state || !state.code) return 'pending';
  switch (state.code) {
    case 'active': return 'active';
    case 'delivered': return 'delivered';
    case 'cancelled': return 'cancelled';
    default: return 'pending';
  }
};

const formatCurrency = (value) => {
  if (value == null) return '-';
  return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value);
};

const InspectCard = ({ setCondition, Selected, recharges: rechargesProp, rechargePage, rechargeTotalPages, onRechargePageChange }) => {
  // Use server-fetched recharges when available, fall back to embedded data
  const recharges = rechargesProp !== undefined ? rechargesProp : ((Selected && Selected.recharges) || []);

  return (
    <div className="inspect-card">
      <CustomButton link tight onClick={() => setCondition(null)} secondary large className="inspect-card__back">
        <ArrowLeftLG className="inspect-card__back-icon" />
        Voltar
      </CustomButton>

      <h5 className="inspect-card__title">Detalhes do cartão ({Selected.number})</h5>

      {recharges.length === 0 ? (
        <div className="inspect-card__card">
          <span className="inspect-card__empty">Sem carregamentos registados.</span>
        </div>
      ) : (
        recharges.map((recharge, i) => (
          <div key={recharge.id || i} className="inspect-card__card">
            <div className="inspect-card__card-grid">
              <div className="inspect-card__field">
                <span className="inspect-card__field-label">Encomenda</span>
                <span className="inspect-card__field-value">{recharge.order ? recharge.order.number : '-'}</span>
              </div>
              <div className="inspect-card__field">
                <span className="inspect-card__field-label">Valor</span>
                <span className="inspect-card__field-value">{formatCurrency(recharge.requested_value)}</span>
              </div>
              <div className="inspect-card__field">
                <span className="inspect-card__field-label">Data do pedido</span>
                <span className="inspect-card__field-value">{formatDate(recharge.requested_at)}</span>
              </div>
              <div className="inspect-card__field">
                <span className="inspect-card__field-label">Estado</span>
                <span className={`inspect-card__status inspect-card__status--${getStatusClass(recharge.state)}`}>
                  {recharge.state ? recharge.state.label : '-'}
                </span>
              </div>
            </div>
          </div>
        ))
      )}
      {rechargeTotalPages > 1 && onRechargePageChange && (
        <ReactPaginate
          pageCount={rechargeTotalPages}
          forcePage={rechargePage - 1}
          onPageChange={(data) => onRechargePageChange(data.selected + 1)}
          containerClassName="pagination"
          activeClassName="active"
          previousLabel="‹"
          nextLabel="›"
        />
      )}
    </div>
  );
};

export default InspectCard;
